import { GLOBAL_COLORS_HOLSTER } from '../config/globalSettings';

export const holsterData = {
  // --- 1. MANUFACTURERS ---
  brands: [
    { id: "sw",     name: "Smith & Wesson" },
    { id: "kimber", name: "Kimber" },
    { id: "ruger",  name: "Ruger" },
    { id: "taurus", name: "Taurus" }
  ],

  // --- 2. GUN MODELS ---
  guns: [
    // ── Smith & Wesson ─────────────────────────────────────────────────────
    { id: "sw_j_frame_2",   brand_id: "sw", name: "J-Frame 2\"  (642/442, 340PD, etc.)", quick_ship: true  },
    { id: "sw_j_frame_3",   brand_id: "sw", name: "J-Frame 3\"  (642/442, 340PD, etc.)", quick_ship: true  },
    { id: "sw_l_frame_25",  brand_id: "sw", name: "L-Frame 2.5\"  (686, 586, etc.)",      quick_ship: true  },
    { id: "sw_l_frame_3",   brand_id: "sw", name: "L-Frame 3\"  (686, 586, etc.)",        quick_ship: true  },
    { id: "sw_l_frame_4",   brand_id: "sw", name: "L-Frame 4\"  (686, 586, etc.)",        quick_ship: true  },
    { id: "sw_l_frame_5",   brand_id: "sw", name: "L-Frame 5\"  (686, 586, etc.)",        quick_ship: true  },
    { id: "sw_386_ng",      brand_id: "sw", name: "Smith & Wesson 386 Night Guard",      quick_ship: true },
    { id: "sw_396_ng",      brand_id: "sw", name: "Smith & Wesson 396 Night Guard",      quick_ship: true },

    // ── Kimber (Quick Ship: 5-7 Days) ──────────────────────────────────────
    { id: "kimber_k6s_2",   brand_id: "kimber", name: "Kimber K6S 2\"",                  quick_ship: true  },
    { id: "kimber_k6s_3",   brand_id: "kimber", name: "Kimber K6S 3\"",                  quick_ship: true  },

    // ── Ruger (Lead Time: 3-5 Weeks) ───────────────────────────────────────
    { id: "ruger_lcr_38",       brand_id: "ruger", name: "Ruger LCR .38",                quick_ship: false },
    { id: "ruger_sp101_38_225", brand_id: "ruger", name: "Ruger SP101 .38 SPL 2.25\"",    quick_ship: false },
    { id: "ruger_sp101_38_3",   brand_id: "ruger", name: "Ruger SP101 .38 SPL 3\"",       quick_ship: false },

    // ── Taurus (Lead Time: 3-5 Weeks) ──────────────────────────────────────
    { id: "taurus_85_605",  brand_id: "taurus", name: "Taurus 85 / 605 .38 SPL 2\" 5rd", quick_ship: false },
    { id: "taurus_856",     brand_id: "taurus", name: "Taurus 856 .38 SPL 2\" 6rd",      quick_ship: false }
  ],

  // --- 3. OPTIONS ---
  hands: [ 
    { id: "right", name: "Right Handed" }, 
    { id: "left",  name: "Left Handed"  } 
  ],

  // OPTIC CUT
  optic_cut: [
    { id: "no",  name: "No Optic Cut",  price: 0 },
    { id: "yes", name: "Yes, Optic Cut", price: 0 }
  ],

  // REVOLVER MOUNTS
  mounts: [
    { 
      id: "dcc_mod4", 
      name: "DCC Mod 4 Universal 1.5\" Belt Clip", 
      price: 0, 
      img_layer_mount:      "/images/mounts/revolver/dcc_mod4_front.png", 
      img_layer_mount_back: "/images/mounts/revolver/dcc_mod4_back.png", 
      description: "High clamping force, heat treated steel alloy."
    },
    { 
      id: "dcc_mod4175", 
      name: "DCC Mod 4 Universal 1.75\" Belt Clip", 
      price: 0, 
      img_layer_mount:      "/images/mounts/revolver/dcc_mod4175_front.png", 
      img_layer_mount_back: "/images/mounts/revolver/dcc_mod4175_back.png",
      description: "High clamping force, heat treated steel alloy."
    }
  ],

  // --- 4. COLORS (Using Global Settings) ---
  colors: GLOBAL_COLORS_HOLSTER,

  // --- 5. EXTRAS ---

  // CLAWS 
  claws: [
    { id: "no",  name: "No Thanks", price: 0 },
    { 
      id: "black", 
      name: "Add Black Concealment Claw", 
      price: 12.00, 
      img_layer_claw_front: "/images/claws/revolver/claw_black_front.png", 
      img_layer_claw_back:  "/images/claws/revolver/claw_black_back.png" 
    },
    { 
      id: "od_green", 
      name: "Add OD Green Concealment Claw", 
      price: 12.00, 
      img_layer_claw_front: "/images/claws/revolver/claw_od_front.png", 
      img_layer_claw_back:  "/images/claws/revolver/claw_od_back.png" 
    },
    { 
      id: "coyote", 
      name: "Add Coyote Concealment Claw", 
      price: 12.00, 
      img_layer_claw_front: "/images/claws/revolver/claw_coy_front.png", 
      img_layer_claw_back:  "/images/claws/revolver/claw_coy_back.png" 
    }
  ],

  breakthrough: [ 
    { id: "no",        name: "No Thanks",                                price: 0    }, 
    { id: "solvent",   name: "Breakthrough Military Grade Solvent",      price: 8.95  },
    { id: "oil",       name: "Breakthrough Battle Born High Purity Oil",  price: 8.95  },
    { id: "lubricant", name: "Breakthrough Battle Born Pro Lubricant",    price: 12.95 },
    { id: "bundle",    name: "Breakthrough Clean Bundle",                 price: 16.00 }
  ],

  warranties: [ 
    { id: "30_day",   name: "30 Day Mfg Warranty", price: 0     }, 
    { id: "lifetime", name: "Lifetime Warranty",   price: 12.99 } 
  ]
};